<template>
  <div class="city u-pointer-none">
    <div class="city__show u-cursor-pointer u-pointer-all" @click.stop="onShowoff">
      <div class="u-box-1by1">
        <div class="u-wrapper-panel city__show__img">
          <img src="/images/show.png" class="u-block u-full-width">
        </div>
      </div>
    </div>
    <transition name="t-fader">
      <div v-if="tuto === 1 || tuto == 2" class="u-wrapper-panel u-overlay u-pointer-all">
        <div class="city__tuto city__tuto--1 u-center u-white" :class="{'is-active': tuto === 1}">
          <div class="u-row u-center u-marg-b-xs">
            <div class="u-w4of8">
              <img src="/images/navigate.png" class="u-full-width">
            </div>
          </div>
          {{ tutorials[0].text }}
        </div>
        <div class="city__tuto city__tuto--2 u-center u-white" :class="{'is-active': tuto === 2}">
          <div class="u-row u-center u-marg-b-xs">
            <div class="u-w4of8">
              <img src="/images/zoom.png" class="u-full-width">
            </div>
          </div>
          {{ tutorials[1].text }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Vector3 } from 'three'

import { webGL } from '@/webGL/WebGL'
import { CameraWalk } from '@/utils/CameraWalk'

import gsap from 'gsap'

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

export default {
  name: 'City',

  data () {
    return {
      tuto: 0
    }
  },

  props: {
    isMap: {
      type: Boolean,
      default: false
    },
    isTuto: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tutorials () {
      return this.$store.getters['data/tutorials']
    }
  },

  mounted () {
    const target = new Vector3(-25, 1, 1)


    // if(this.$route.query.editor) {
    //   this.controls = new OrbitControls( webGL.camera, this.$el )
    //   return
    // }

    this.cameraWalk = new CameraWalk(webGL.camera, webGL.scene, this.$store.getters['global/lvlScroll'], this.$device.isTouch)
    this.cameraWalk.onStartMoving(() => {
      this.$hub.emit('cameraMove', true)
    })
    this.cameraWalk.onEndMoving(() => {
      requestAnimationFrame(()=>{
        this.$hub.emit('cameraMove', false)
      })
    })

    gsap.fromTo(webGL.camera.position, {
      x: webGL.camera.position.x,
      y: webGL.camera.position.y,
      z: webGL.camera.position.z,
    }, {
      x: target.x - 20,
      y: target.y + 30,
      z: target.z + 50,
      duration: 3,
      ease: 'power4.inOut',
      onComplete: () => {
        this.cameraWalk.active = true
      }
    })

    gsap.to(webGL.camera.look, {
      x: target.x,
      y: target.y,
      z: target.z,
      duration: 3,
      ease: 'power4.inOut',
      onUpdate: () => {
        webGL.camera.forceUpdateLook = true
      }
    })

    if (this.isTuto) {
      this.onTuto()
    }

    this.$root.$el.addEventListener(this.$device.pointerdown, this.onPointerdown)
    this.$root.$el.addEventListener(this.$device.pointerup, this.onPointerup)
    this.$root.$el.addEventListener(this.$device.pointermove, this.onPointermove)
  },

  beforeDestroy() {
    this.cameraWalk.onDestroy()
  },

  methods: {
    onShowoff () {
      this.$ga.send('Menu', 'Click', 'Show me around')
      this.$hub.emit('showoff:start')
    },
    onPointerdown (event) {
      this.cameraWalk.onPointerdown(this.$device.getPointerPosition(event))
    },
    onPointerup (event) {
      this.cameraWalk.onPointerup()
    },
    onPointermove (event) {
      this.cameraWalk.onPointermove(this.$device.getPointerPosition(event))
    },
    onTuto () {
      this.tuto = 1
      setTimeout(() => {
        this.tuto = 2
        setTimeout(() => {
          this.tuto = 0

          this.$hub.emit('onBoarding:step', {
            step: this.$store.getters['data/tutorials'][2],
            pad: { h: 10, v: 10 },
            isNextBtn: true,
            height: 300,
            callback: () => {
              this.$router.push({ ...this.$local('district'), params: {slug: this.$store.getters['data/districts'][3].slug } })
            }
          })
        }, 6000)
      }, 6000)
    }
  },
  watch: {
    isMap () {
      if (this.isMap) {
        this.cameraWalk.isMap = true
      }
      else {
        this.cameraWalk.isMap = false
      }
    },
    isTuto () {
      this.onTuto()
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.city
  &__tuto
    width 150px
    position absolute
    top 50%
    left 50%
    transform translate(-50%, 50%)
    opacity 0
    
    &--1.is-active
      animation movehor 2s infinite linear
    
    &--2.is-active
      animation movevert 2s infinite linear
      width 130px

  &__show
    position absolute
    bottom 0
    right 0
    width 10%
    min-width 100px    
    
    &:before
      content ''
      position absolute
      top 0
      left 0
      width 140%
      height 140%
      background $colors.grey
      border-radius 50%
      transform scale(1) translateZ(0)
      transition: transform .15s ease-in-out-quad
    
    &:hover:before
      transform scale(1.1) translateZ(0)

    &__img
      padding 30% 20% 20% 30%

@keyframes movehor
  0%
    transform translate3d(calc(-50% - 100px), -50%, 0)
    opacity 0
  10%
    transform translate3d(calc(-50% - 80px), -50%, 0)
    opacity 1
  90%
    transform translate3d(calc(-50% + 80px), -50%, 0)
    opacity 1
  100%
    transform translate3d(calc(-50% + 100px), -50%, 0)
    opacity 0

@keyframes movevert
  0%
    transform translate3d(-50%, calc(-50% - 100px), 0)
    opacity 0
  10%
    transform translate3d(-50%, calc(-50% - 80px), 0)
    opacity 1
  90%
    transform translate3d(-50%, calc(-50% + 80px), 0)
    opacity 1
  100%
    transform translate3d(-50%, calc(-50% + 100px), 0)
    opacity 0
</style>